import { isWithinInterval } from 'date-fns';

import {
    Column,
    flattenArrayWithObj,
    Row,
} from '../../../coaching-observation/experimental.grid';
import {
    CoverageDataDto,
    RosterType,
} from '../../coverage.coaching-insight.model';
import { ScheduleEventDto } from '../../schedule.coaching-insight.model';
import {
    CellContext,
    ColumnContext,
    ColumnType,
    RowContext,
} from '../coaching-coverage-grid.model';
import { DateRange } from '../select-period-date-range.component';

export function updateRows(
    rosterType: RosterType,
    data: CoverageDataDto,
    periodDateRanges: DateRange[],
    scheduleEvents: ScheduleEventDto[],
    columns: Array<Column<ColumnContext>>,
    rows: Array<Row<RowContext, CellContext>>,
    dateRange: DateRange,
): void {
    const cols = [
        ColumnType.COACHING_COVERAGE_PERCENT.toString(),
        ColumnType.OBSERVATION_COVERAGE_PERCENT.toString(),
        ColumnType.COMMITMENT_COVERAGE_PERCENT.toString(),
    ];
    const rowsFlatten = flattenArrayWithObj(rows, 'children');
    rowsFlatten.forEach((r) => {
        // data should already be padded and sorted. if this fails something else is wrong
        const index = periodDateRanges.findIndex(
            (e) =>
                e.startDate.getTime() === dateRange.startDate.getTime() &&
                e.endDate.getTime() === dateRange.endDate.getTime(),
        );
        // assuming the period columns are in asc date order
        let offset = 0;
        r.cells
            .filter((l) => cols.some((e) => l.columnId.startsWith(e)))
            .forEach((l, li) => {
                // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                const c = columns.find(
                    (e) =>
                        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                        e.children &&
                        e.children.some((ee) => ee.id === l.columnId),
                );
                const overallDat = data.overall.find(
                    (e) => e.userId === l.ctx.user.userId,
                );
                const periodDat = data.periods.find(
                    (e) => e.userId === l.ctx.user.userId,
                );
                const week = periodDateRanges[index + offset];
                const schedule = !week
                    ? null
                    : scheduleEvents.filter((e) => {
                          return (
                              e.participants.findIndex(
                                  (ee) => ee.userId === l.ctx.user.userId,
                              ) !== -1 &&
                              isWithinInterval(e.eventDate, {
                                  start: week.startDate,
                                  end: week.endDate,
                              })
                          );
                      });

                c.ctx.week = week;
                l.ctx.overall = overallDat;
                l.ctx.period = periodDat;
                l.ctx.schedule = schedule;

                if ((li + 1) % 3 === 0) {
                    offset++;
                }
            });
    });
}
